import { EyeSlashIcon } from '@heroicons/react/24/outline';
import React from 'react';

// #region ViewAsEnded
/** Where a "view as customer" tab lands once the view is over (exit, time up, or access removed). */
export const ViewAsEnded: React.FunctionComponent<{}> = (): React.ReactElement => (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4">
        <div className="w-full max-w-sm rounded-2xl border border-surface-border bg-surface-raised p-6 text-center shadow-sm">
            <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-surface-muted">
                <EyeSlashIcon className="h-5 w-5 text-zinc-500" />
            </div>
            <h1 className="text-base font-semibold text-zinc-900 dark:text-zinc-100">This view has ended</h1>
            <p className="mt-1 text-sm text-zinc-500 dark:text-zinc-400">
                You’re no longer viewing the customer’s dashboard. It’s recorded on the lead’s timeline.
            </p>
            <div className="mt-5 flex justify-center gap-2">
                <button type="button" onClick={() => window.close()} className="rounded-lg bg-zinc-900 px-3 py-1.5 text-sm font-semibold text-white hover:bg-zinc-700 dark:bg-white dark:text-zinc-900">
                    Close tab
                </button>
                <a href="/sales/inbox" className="rounded-lg border border-surface-border px-3 py-1.5 text-sm font-semibold text-zinc-700 hover:bg-surface-muted dark:text-zinc-200">
                    Back to Sales
                </a>
            </div>
        </div>
    </div>
);

export default ViewAsEnded;
